exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipe-convert{align-items:center;display:flex;justify-content:center;margin-top:-4px}.recipe-convert__toggle{display:flex;margin-right:4px}.recipe-convert__info{margin-right:4px}.recipe-convert__tooltips{display:flex;gap:6px;align-items:center;height:38px;margin-right:32px}@media (max-width: 480px){.recipe-convert__tooltips{margin-right:16px}}.recipe-convert__progress,.recipe-convert__error{margin-right:16px}.recipe-convert .MuiGrid-container{width:auto}@media print{.recipe-convert{display:none}}\n", ""]);

// exports
exports.locals = {
	"recipe-convert": "recipe-convert",
	"recipe-convert__toggle": "recipe-convert__toggle",
	"recipe-convert__info": "recipe-convert__info",
	"recipe-convert__tooltips": "recipe-convert__tooltips",
	"recipe-convert__progress": "recipe-convert__progress",
	"recipe-convert__error": "recipe-convert__error",
	"MuiGrid-container": "MuiGrid-container"
};